import styled from 'styled-components'

const PageStyle = styled.main`
	margin-top: var(--containerMarginTop);
	margin-bottom: var(--containerMarginBottom);
`
export default PageStyle
